<template>
  <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex xs12>
                      <h1> Cadastro de Usuário </h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    </v-layout>


                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap v-if="!isMakerlab">
                      <v-flex xs12>
                        <v-stepper v-model="e1" alt-labels>
                          <v-stepper-header>
                            <v-stepper-step step="1" :complete="e1 > 1">Básico</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="e1 > 2">Endereço</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3" :complete="e1 > 3" >Complementar</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="4">Submeter</v-stepper-step>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content step="1">
                              <step1 @next="e1 = 2"
                              v-on:result="result"
                              @dados1="step1Atual"></step1>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                              <step2 @next="e1 = 3"
                              @prev="e1 = 1"
                              @next2="e1 = 4"
                              v-on:result="result"
                              :step1Data="step1Data"
                              @dados2="step2Atual"></step2>                              
                            </v-stepper-content>
                            <v-stepper-content step="3">
                              <step3 @next="e1 = 4"
                              @prev="e1 = 2"
                              v-on:result="result"
                              @dados3="step3Atual"
                              :step2Data="step2Data"
                              :step1Data="step1Data"></step3>
                            </v-stepper-content>
                            <v-stepper-content step="4">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <h2>Deseja finalizar o cadastro?</h2>
                                  <br>
                                  <v-flex xs6>
                                    <p><strong>Papel: </strong>{{ step1Data.groups }}</p>
                                    <br>
                                    <p><strong>Nome: </strong>{{ step1Data.first_name }}</p>
                                    <br>
                                    <p><strong>Sobrenome: </strong>{{ step1Data.last_name }}</p>
                                    <br>
                                    <p><strong>Nome de usuário: </strong>{{ step1Data.username }}</p>
                                    <br>
                                    <p><strong >Unidade: </strong><v-chip label 
                                                                    v-for="un 
                                                                    in step1Data.unidade"
                                                                    :key='un.name'
                                                                    color='amber'
                                                                    outline>
                                                                        {{un}}
                                                                  </v-chip></p>
                                    <br>
                                    <p><strong>Email: </strong>{{ step1Data.email }}</p>
                                    <br>
                                    <p><strong>Data de nascimento: </strong>{{ step1Data.birthdate }}</p>
                                    <br>
                                    <p><strong>Gênero: </strong>{{ step1Data.gender }}</p>
                                    <br>
                                    <p><strong>RG: </strong>{{ step1Data.rg }}</p>
                                    <br>
                                  </v-flex>
                                </v-flex>
                                <v-btn color="primary"  @click.native="e1 = 3" >voltar</v-btn>
                                <v-btn color="primary"  @click.native="cadastrar" >Finalizar</v-btn>
                              </v-layout>
                            </v-stepper-content>                        
                          </v-stepper-items>  
                        </v-stepper>
                      </v-flex>
                    </v-layout>
                    <!-- Quando for makerLab -->
                    <v-layout row wrap v-if="isMakerlab">
                      <v-flex xs12>
                        <v-stepper v-model="e1" alt-labels>
                          <v-stepper-header>
                            <v-stepper-step step="1" :complete="e1 > 1">Básico</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2">Submeter</v-stepper-step>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content step="1">
                              <step1 @next="e1 = 2"
                              v-on:result="result"
                              @dados1="step1Atual"></step1>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <h2>Deseja finalizar o cadastro?</h2>
                                  <br>
                                  <v-flex xs6>
                                    <p><strong>Papel: </strong>{{ step1Data.groups }}</p>
                                    <br>
                                    <p><strong>Nome: </strong>{{ step1Data.first_name }}</p>
                                    <br>
                                    <p><strong>Sobrenome: </strong>{{ step1Data.last_name }}</p>
                                    <br>
                                    <p><strong>Nome de usuário: </strong>{{ step1Data.username }}</p>
                                    <br>
                                    <p><strong >Unidade: </strong><v-chip label 
                                                                    v-for="un 
                                                                    in step1Data.unidade"
                                                                    :key='un.name'
                                                                    color='amber'
                                                                    outline>
                                                                        {{un}}
                                                                  </v-chip></p>
                                    <br>
                                    <p><strong>Email: </strong>{{ step1Data.email }}</p>
                                    <br>
                                  </v-flex>
                                </v-flex>
                                <v-btn color="primary"  @click.native="e1 = 1" >voltar</v-btn>
                                <v-btn color="primary"  @click.native="cadastrar" >Finalizar</v-btn>
                              </v-layout>
                            </v-stepper-content>                        
                          </v-stepper-items>  
                        </v-stepper>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
import Step1 from './CadastroSteps/Step1.vue'
import Step2 from './CadastroSteps/Step2.vue'
import Step3 from './CadastroSteps/Step3.vue'
export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  data () {
    return {
      e1: 1,
      step1Data: [],
      step2Data: [],
      step3Data: [],
      teste: ['teste1', '2'],
      result: {}
    }
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  methods: {
    step1Atual (result) {
      this.step1Data = result
      // console.log(this.step1Data)
    },
    step2Atual (result) {
      this.step2Data = result
      // console.log(this.step2Data)
    },
    step3Atual (result) {
      this.step3Data = result
      console.log(this.step3Data)
    },
    cadastrar () {
      var payload = Object.assign(this.step1Data, this.step2Data, this.step3Data)
      console.log(payload)
      let self = this
      api.request('POST', 'create-user/', payload).then(resp => {
        console.log(resp)
        let name = '/usuarios/' + resp.data.username
        self.animation = false
        self.$router.push(name)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/Cadastro.vue